import React from "react";
import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader__container">
      <div className="loadingio-spinner-spin-vk1ws7sx35g">
        <div className="ldio-yaze223xu8n">
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
